import React from "react";
import "./style.scss";
import withSlideUpModal from "../../../utils/hoc/withSlideUpModalComponent";
import ProBadge from "../../../assets/icons/ProBadge";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux-stores/store";
import { FREE_SUBSCRIPTION_PLAN_ID } from "../../../constants/constants";
import FeaturedSlotsIcon from "../../../assets/icons/FeaturedSlotsIcon";
import PriorityRankingIcon from "../../../assets/icons/PriorityRankingIcon";
import HighValueCampaignPassIcon from "../../../assets/icons/HighValueCampaignPassIcon";

type Props = {
    onClose: () => void;
};

const ProFeaturesModal: React.FC<Props> = () => {
    const activePlan = useSelector((state: RootState) => state.influencer.active_plan);
    const upgradeHref = activePlan?.plan?.id === FREE_SUBSCRIPTION_PLAN_ID ? "/subscription-plans" : "/subscription";

    return (
        <div className="pro-features-modal" data-node-id="1546:12868">
            <div className="pfm__content pb-4 pt-0">
                <div className="pfm__grid">
                    <div className="pfm__card">
                        <div className="pfm__cardMedia pfm__cardMedia--badge" aria-hidden="true">
                            <span className="pfm__badgeIcon">
                                <FeaturedSlotsIcon />
                            </span>
                        </div>
                        <div className="pfm__cardText">
                            <div className="pfm__cardTitle text-dark fw-700">Featured Slot</div>
                            <div className="pfm__cardDesc">Appear at the top of brand applicant lists.</div>
                        </div>
                    </div>

                    <div className="pfm__card">
                        <div className="pfm__cardMedia pfm__cardMedia--badge" aria-hidden="true">
                            <span className="pfm__badgeIcon">
                                <ProBadge />
                            </span>
                        </div>
                        <div className="pfm__cardText">
                            <div className="pfm__cardTitle text-dark fw-700">Pro badge visibility</div>
                            <div className="pfm__cardDesc">Stand out to brands instantly with a Pro badge</div>
                        </div>
                    </div>

                    <div className="pfm__card">
                        <div className="pfm__cardMedia pfm__cardMedia--badge" aria-hidden="true">
                            <span className="pfm__badgeIcon">
                                <PriorityRankingIcon />
                            </span>
                        </div>
                        <div className="pfm__cardText">
                            <div className="pfm__cardTitle text-dark fw-700">Priority Ranking</div>
                            <div className="pfm__cardDesc">Rank higher in brand sorting</div>
                        </div>
                    </div>

                    <div className="pfm__card">
                        <div className="pfm__cardMedia pfm__cardMedia--badge" aria-hidden="true">
                            <span className="pfm__badgeIcon">
                                <HighValueCampaignPassIcon />
                            </span>
                        </div>
                        <div className="pfm__cardText">
                            <div className="pfm__cardTitle text-dark fw-700">Access to high-value campaigns</div>
                            <div className="pfm__cardDesc">Get invited to premium brand collaborations</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pfm__footer">
                <Link className="pfm__cta" to={{ pathname: upgradeHref }}>
                    Upgrade to PRO
                </Link>
            </div>
        </div>
    );
};

export default withSlideUpModal(ProFeaturesModal, "Unlock Exclusive Benefits", true);